import * as React from "react";

import { Button } from "mpulse-design-system";

const AddMetadataButton = ({ metadataLabel, setPopupProps, ...props }) => {
  const handleClick = () => {
    setPopupProps({
      hidden: false,
      isNew: true,
    });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      size="medium"
      {...props}
      onClick={handleClick}
    >
      Add {metadataLabel}
    </Button>
  );
};

export default AddMetadataButton;
